import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import { DateRangePicker } from "@ui";
import { useParams } from "react-router-dom";
import { useGetProjectDetails } from "../queries/query-hooks/workspace/workspace-hook";
import dayjs from "dayjs";
import { formatLocalizedDate } from "../common/utils/utils";
import Skeleton from "../components/skeleton";

const TextAndDateFilter = ({
  searchText = "",
  filterText = "",
  searchInputText = "",
  onSearchFilterTextHanlder = () => {},
  setSearchInputText = () => {},
  setDateRangePayload = () => {},
  dateLabel,
}) => {
  const { project_id } = useParams();
  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id, true);

  useEffect(() => {
    if (projectDetails && projectDetails?.length > 0) {
      const today = dayjs();
      const projectEndDate = dayjs(projectDetails[0]?.project_end_date);
      let result = projectDetails[0]?.project_end_date;

      if (
        projectEndDate &&
        (projectEndDate.isAfter(today) || projectEndDate.isSame(today, "day"))
      ) {
        result = today.subtract(1, "day");
      } else {
        result = projectEndDate;
      }

      setDateRangePayload({
        start_date: formatLocalizedDate(
          new Date(projectDetails[0]?.project_start_date),
          "YYYY-MM-DD[T]00:00:00.000Z"
        ),
        end_date: formatLocalizedDate(
          new Date(result),
          "YYYY-MM-DD[T]23:59:59.000Z"
        ),
      });
    }
  }, [projectDetails]);

  const projectStartDate = projectDetails?.at(0)?.project_start_date || "";
  const projectEndDate = projectDetails?.at(0)?.project_end_date || "";

  const today = new Date();
  let endDateLimit = new Date(projectEndDate);

  const todayDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const endDateOnly = new Date(
    endDateLimit.getFullYear(),
    endDateLimit.getMonth(),
    endDateLimit.getDate()
  );

  if (endDateOnly.getTime() >= todayDate.getTime()) {
    endDateLimit = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 1
    );
  }

  return (
    <Card className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between rounded-2 mb-0 px-3 gap-5">
      <div className="d-flex py-3 align-items-center gap-2 flex-grow-1">
        <p className="p-0 m-0 flex-shrink-0">{searchText}</p>
        <div className="w-50">
          <input
            className="form-control rounded-2 p-2 w-100"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchInputText}
            onChange={(e) => setSearchInputText(e.target.value)}
            onKeyDown={onSearchFilterTextHanlder}
          />
        </div>
      </div>

      <div className="d-flex align-items-center py-3">
        <div>
          <p className="m-0 me-3">{filterText}</p>
        </div>

        {!isProjectDetailsLoading ? (
          <div>
            <DateRangePicker
              startDate={projectStartDate}
              projectEndDate={projectEndDate}
              endDate={endDateLimit}
              setDateRangePayload={setDateRangePayload}
              dateLabel={dateLabel}
            />
          </div>
        ) : (
          <Skeleton variant="text" height={50} width={230} />
        )}
      </div>
    </Card>
  );
};

export default TextAndDateFilter;
